function wrapFacets() {
  const quicklinksContainer = document.querySelector('.collection_quicklinks');
  const filterSortingViewbyContainer = document.querySelector('.filter-sorting-viewby');
  const facetsForm = document.querySelector('.facets__form');
  if (facetsForm) facetsForm.classList.remove('stack');

  const quicklinksWidth = quicklinksContainer?.offsetWidth || 0;
  const filterSortingViewbyWidth = filterSortingViewbyContainer?.offsetWidth || 0;
  const facetsContainerWidth = quicklinksWidth + filterSortingViewbyWidth + 50;

  const viewportWidth = document.documentElement.clientWidth;
  facetsContainerWidth > viewportWidth ? facetsForm.classList.add('stack') : facetsForm.classList.remove('stack');
}

function handleQuicklinksDrag() {
  const quicklinks = document.querySelector('.quicklinks');

  let isDown = false;
  let startX;
  let scrollLeft;
  if (quicklinks) {
    quicklinks.addEventListener('mousedown', (e) => {
      isDown = true;
      quicklinks.classList.add('dragging');
      startX = e.pageX - quicklinks.offsetLeft;
      scrollLeft = quicklinks.scrollLeft;
    });

    quicklinks.addEventListener('mouseleave', () => {
      isDown = false;
      quicklinks.classList.remove('dragging');
    });

    quicklinks.addEventListener('mouseup', () => {
      isDown = false;
      quicklinks.classList.remove('dragging');
    });

    quicklinks.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - quicklinks.offsetLeft;
      const walk = (x - startX) * 1.5;
      quicklinks.scrollLeft = scrollLeft - walk;
    });
  }
}

document.addEventListener('DOMContentLoaded', function () {
  wrapFacets();
  handleQuicklinksDrag();
});
window.addEventListener('resize', function () {
  wrapFacets();
  handleQuicklinksDrag();
});



let lastScrollTop = 0;

function handleCollectionFilters() {
  const filterElement = document.querySelector("#main-collection-filters");
  if (!filterElement) return;

  // Subtract 2px to offset the .shopify-section-header-sticky `top: -1px` rule and sub-pixel rounding,
  // so the filter sits flush with the visible bottom of the sticky header.
  const raw = getComputedStyle(document.body).getPropertyValue('--header-height');
  const headerHeight = raw ? parseFloat(raw) - 2 : 0;
  if (window.innerWidth < 990) {
    window.addEventListener("scroll", function () {
      let currentScroll = window.scrollY || document.documentElement.scrollTop;

      if (currentScroll > lastScrollTop) {
        // Scrolling down → hide filters
        filterElement.style.top = "0";
      } else if (currentScroll < lastScrollTop) {
        // Scrolling up → show filters under header
        filterElement.style.top = headerHeight + "px";
      }

      lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
    }, false);
  }
}

handleCollectionFilters();
window.addEventListener("resize", handleCollectionFilters);

